
import {Injectable} from '@angular/core';
import {ApiService} from "../../api.service";

@Injectable({
  providedIn: 'root'
})
export class ApiAdminCustomerLocationsService {

  apiUri = '/api/admin/customer/location'

  constructor(private apiService: ApiService) {
  }

  options() {
    return this.apiService.get(`${this.apiUri}/options`);
  }

  get(id) {
    return this.apiService.get(`${this.apiUri}/${id}`);
  }

  delete(id) {
    return this.apiService.delete(`${this.apiUri}/${id}`);
  }

  create(data) {
    return this.apiService.post(this.apiUri, data);
  }

  update(id, data) {
    return this.apiService.put(`${this.apiUri}/${id}`, data);
  }

  search(customerId){
    return this.apiService.get(`${this.apiUri}/search`, {CustomerId: customerId});
  }


}



